import React, {Component} from 'react';
import {Button} from '@betareader/design-system';

import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom';
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {clearCommentList, removeFilteredReaders} from '../../modules/comment';
import {setCurrentContentVersion, createNewVersion} from '../../modules/book';

import accessUtil from '../../utils/accessUtil';

export class VersionSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps) {
    const {match, currentBook} = this.props;
    if (match) {
      const {versionNumber} = match.params;
      const prevVersionNumber =
        prevProps.match &&
        prevProps.match.params &&
        prevProps.match.params.versionNumber;
      if (versionNumber && versionNumber !== prevVersionNumber) {
        const currentContentVersion =
          currentBook &&
          currentBook.content &&
          currentBook.content.find(
            contentVersion =>
              parseInt(contentVersion.versionNumber) === parseInt(versionNumber)
          );
        if (currentContentVersion && currentContentVersion._id !== this.props.currentContentVersion?._id) {
          this.props.setCurrentContentVersion(currentContentVersion);
        }
      }
    }
  }

  getContentVersion = () => {
    const {
      currentBook,
      t,
      currentContentVersion
    } = this.props;
    const hasContent = currentBook.content && currentBook.content.length > 0;
    if (!hasContent) {
      return <span style={{color: 'lightgray'}}>(v1)</span>;
    }
    const lastVersion = currentBook.content[currentBook.content.length - 1];
    const lastVersionHasParts =
      lastVersion.parts && lastVersion.parts.length > 0;
    const canEdit = accessUtil.isAllowed(currentBook.access, ['edit']);
    return (
      <span style={{display: 'inline-flex', alignItems: 'center', gap: 'var(--br-space-2)'}}>
        <label className='br-field' htmlFor='book-content-version'>
          <span className='br-field__label' style={{position: 'absolute', width: 1, height: 1, overflow: 'hidden'}}>
            {t('Version')}
          </span>
          <select id='book-content-version' className='br-field__input'
            style={{width: 'auto'}}
            value={currentContentVersion?._id || ''}
            onChange={event => {
              const content = currentBook.content.find(version => version._id === event.target.value);
              if (content) this.props.changePage(`/books/${currentBook._id}/content/v${content.versionNumber}`);
            }}>
            {!currentContentVersion && <option value='' disabled>{t('Version')}</option>}
            {currentBook.content.map(content => (
              <option key={content._id} value={content._id}>v{content.versionNumber}</option>
            ))}
          </select>
        </label>
        {canEdit && (
          <Button variant='secondary' size='small' onClick={this.addNewVersion}
            disabled={!lastVersionHasParts}
            title={!lastVersionHasParts ? t('AllVersionsNeedContent') : undefined}>
            {t('NewVersion')}
          </Button>
        )}
      </span>
    );
  };

  addNewVersion = event => {
    event.preventDefault();
    event.stopPropagation();
    const {idToken, currentBook} = this.props;
    this.props.createNewVersion(
      idToken,
      currentBook._id,
      [],
      newBookVersion => {
        this.props.history.replace(
          `/books/${currentBook._id}/content/v${newBookVersion.content.length}`
        );
      }
    );
  };

  render() {
    return <span>{this.getContentVersion()}</span>;
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
  commentsSidebarVisible: state.app.commentsSidebarVisible,
  currentContentVersion: state.book.currentContentVersion,
  filteredReaders: state.comment.filteredReaders
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearCommentList,
      setCurrentContentVersion,
      createNewVersion,
      removeFilteredReaders,
      changePage: newPage => push(newPage)
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(VersionSelector))
);
